/**
 * Shared helpers for booking API proxies (`{NEXT_PUBLIC_API_BASE_URL}/api/user/...`).
 */

export const BOOKING_UPSTREAM_TIMEOUT_MS = 30_000;

export function getBookingUpstreamConfig() {
  const rawBase = (process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:5000/api/user').trim().replace(/\/+$/, '');
  let base = rawBase;
  if (!base.endsWith('/api/user')) {
    if (base.endsWith('/api')) {
      base = `${base}/user`;
    } else {
      base = `${base}/api/user`;
    }
  }
  const key = (process.env.NEXT_PUBLIC_CLIENTPUBLIC_AUTH || 'tp_pub_a544456a396147246b').trim();
  return { base, key };
}

/** android | ios | web — from `platform` cookie when set, else web. Legacy "app" maps to android. */
export function getPlatformFromRequest(request) {
  const cookieHeader = request.headers.get('cookie');
  const platformMatch = cookieHeader?.match(/(?:^|;\s*)platform=([^;]+)/i);
  const platformFromCookie = platformMatch
    ? decodeURIComponent(platformMatch[1].trim()).toLowerCase()
    : null;
  if (platformFromCookie === 'android' || platformFromCookie === 'ios') {
    return platformFromCookie;
  }
  if (platformFromCookie === 'app') {
    return 'android';
  }
  return 'web';
}

/** Bearer + forwarded Cookie & X-Checkout-Token header for upstream. */
export function buildUpstreamHeaders(request, key, extra = {}) {
  const headers = { Authorization: `Bearer ${key}`, ...extra };
  const cookie = request.headers.get('cookie');
  if (cookie) headers.Cookie = cookie;

  const checkoutToken = request.headers.get('x-checkout-token');
  if (checkoutToken) headers['X-Checkout-Token'] = checkoutToken;

  return headers;
}

export async function jsonFromUpstreamResponse(upstream) {
  const text = await upstream.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    return { error: upstream.statusText || 'Upstream error', raw: text };
  }
}
